import React from 'react';
import { parse } from 'qs';

import { jwtSignin } from '../actions/userActions';
import { setWebView } from '../actions/uiActions';

const { isNative, useToken } = parse(window.location.search, {
  ignoreQueryPrefix: true
});

/**
 * This hook was added to allow authentication from a react native webview, it will look on mount if the url has the following query params:
 * ?isNative=true&useToken=<valid draftstars jwt>
 * it was made to allows users to use fantasyinsider cruncher via a webview from the native app but it can be used for anything else..
 * it triggers 2 actions on the redux store:
 * - set the globalState.ui.isNativeWebView to true
 * - store the jwt passed in the url in the cookies and calls the api to refresh the fantasy user so the app will enter a logged in state
 *
 * @param {*} dispatch redux dispatcher
 */

const useWebViewAuthentication = dispatch => {
  React.useEffect(() => {
    if (isNative && useToken) {
      dispatch(setWebView());
      dispatch(jwtSignin(useToken));
    }
  }, [dispatch]);
};

export default useWebViewAuthentication;
